"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Modal = _interopRequireDefault(require("../shared/Modal"));

var _Row = _interopRequireDefault(require("@emcasa/ui-dom/components/Row"));

var _header = _interopRequireDefault(require("./header"));

var _phone = _interopRequireDefault(require("./steps/phone"));

var _token = _interopRequireDefault(require("./steps/token"));

var _success = _interopRequireDefault(require("./steps/success"));

var _tokenError = _interopRequireDefault(require("./steps/token-error"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@emcasa/ui-dom/components/Button"));

var _Text = _interopRequireDefault(require("@emcasa/ui-dom/components/Text"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Login =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Login, _Component);

  function Login() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Login);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Login)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", _objectSpread({}, Login.INITIAL_STATE));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClose", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      _this.setState(_objectSpread({}, Login.INITIAL_STATE));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "open", function () {
      var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return _this.setState({
        phone: phone,
        isOpen: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "goToStep", function (stepName) {
      return _this.setState({
        currentStep: stepName
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "requestToken", function (phone) {
      _this.setState({
        phone: phone
      });

      var _this$props = _this.props,
          requestToken = _this$props.requestToken,
          onError = _this$props.onError;
      return requestToken(phone, onError);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "submitToken", function (token) {
      var _this$props2 = _this.props,
          submitToken = _this$props2.submitToken,
          onSuccess = _this$props2.onSuccess,
          onError = _this$props2.onError;
      return submitToken(_this.state.phone, token, onSuccess, onError);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderStepByState", function () {
      switch (_this.state.currentStep) {
        case Login.STEP_NAMES.phone:
          return (0, _jsx2["default"])(_phone["default"], {
            title: _this.props.title,
            renderInfo: _this.props.renderInfo,
            phone: _this.state.phone,
            requestToken: _this.requestToken,
            goToStep: _this.goToStep
          });

        case Login.STEP_NAMES.token:
          return (0, _jsx2["default"])(_token["default"], {
            submitToken: _this.submitToken,
            goToStep: _this.goToStep
          });

        case Login.STEP_NAMES.success:
          return _this.props.renderSuccess({
            onClose: _this.onClose
          });

        case Login.STEP_NAMES.tokenError:
          return (0, _jsx2["default"])(_tokenError["default"], {
            goToStep: _this.goToStep
          });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderIsOpen", function () {
      return (0, _jsx2["default"])(_react.Fragment, {}, void 0, _this.props.children({
        open: _this.open,
        close: _this.onClose
      }), (0, _jsx2["default"])(_Modal["default"], {
        onClose: _this.onClose
      }, void 0, (0, _jsx2["default"])(_Row["default"], {
        p: "30px",
        height: "280px",
        flexDirection: "column"
      }, void 0, (0, _jsx2["default"])(_header["default"], {
        onClose: _this.onClose
      }), (0, _jsx2["default"])(_Row["default"], {
        justifyContent: "center",
        alignItems: "center",
        height: "100%"
      }, void 0, _this.renderStepByState()))));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderIsClosed", function () {
      return _this.props.children({
        open: _this.open,
        close: _this.onClose
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Login, [{
    key: "render",
    value: function render() {
      return this.state.isOpen ? this.renderIsOpen() : this.renderIsClosed();
    }
  }]);
  return Login;
}(_react.Component);

(0, _defineProperty2["default"])(Login, "STEP_NAMES", {
  phone: 'phone',
  token: 'token',
  tokenError: 'tokenError',
  success: 'success',
  loading: 'loading'
});
(0, _defineProperty2["default"])(Login, "INITIAL_STATE", {
  currentStep: Login.STEP_NAMES.phone,
  phone: '',
  isOpen: false
});

var _ref2 =
/*#__PURE__*/
(0, _jsx2["default"])(_Text["default"], {}, void 0, "OLAR");

Login.defaultProps = {
  submitToken: function submitToken() {
    return new Promise(function (_resolve, reject) {
      window.setTimeout(_resolve, 1000);
    });
  },
  requestToken: function requestToken() {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, 500);
    });
  },
  children: function children(_ref) {
    var open = _ref.open,
        close = _ref.close;
    return (0, _jsx2["default"])("div", {}, void 0, _ref2, (0, _jsx2["default"])(_Button["default"], {
      onClick: open
    }, void 0, "Open"));
  },
  renderInfo: function renderInfo() {
    return null;
  },
  renderSuccess: function renderSuccess(_ref3) {
    var onClose = _ref3.onClose;
    return (0, _jsx2["default"])(_success["default"], {
      onContinue: onClose
    });
  },
  title: 'Entre na sua conta'
};
Login.propTypes = {
  submitToken: _propTypes["default"].func.isRequired,
  requestToken: _propTypes["default"].func.isRequired,
  renderInfo: _propTypes["default"].func.isRequired,
  renderSuccess: _propTypes["default"].func.isRequired,
  title: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func,
  onSuccess: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  children: _propTypes["default"].func
};
var _default = Login;
exports["default"] = _default;